import { connect } from 'react-redux';
import { InvoiceEditor, mapDispatchToInvoiceEditorProps, mapStateToInvoiceEditorProps } from '@codametrix/shared-views';
export const InvoiceEditorComponent = connect(mapStateToInvoiceEditorProps, mapDispatchToInvoiceEditorProps)(InvoiceEditor);
